export const StoreQueryTagEnum = {};
